module.exports = __webpack_public_path__ + "img/range_magento.598262af.svg";